import styled from 'styled-components'

export const Container = styled.div`
    position: absolute;
    top: 50vh;
    left: 50vw;
    transform: translate(-50%, -50%);
    background-color: #fff;
    border-radius: 1vw;
    z-index: 1;
    padding:1.8rem;
    width:30rem;
    font-family: 'Inter', sans-serif;
`

export const HeaderDiv = styled.div`
    display: flex;
    justify-content: center;
    align-items: center;
    width: 100%;

    img{
        width: 1.7rem;
    }
`

export const MainText = styled.h2`
    font-size: 1.4rem;
    text-align: center;
    font-weight: 700;
`

export const TipText = styled.p`
    font-size: .8rem;
    font-weight: 400;
    text-align: center;
`

export const ButtonsDiv = styled.div`
    display: flex;
    margin-top: 2rem;
    justify-content: center;
    font-weight: 700;
    gap:1rem;
`

export const YesDeleteButton = styled.div`
    display: flex;
    align-items: center;
    width: auto;
    height: 5.8vh;
    padding:1.5rem;
    background-color: #FD7477;
    color: #fff;
    border-radius: 3vw;
    cursor: pointer;
`

export const BackButton = styled.div`
    display: flex;
    align-items: center;
    width: auto;
    height: 5.8vh;
    padding:1.5rem;
    background-color: #fff;
    color: #FD7477;
    border-radius: 3vw;
    cursor: pointer;
    border: 2px solid #FD7477;
`